// Vitesse de lecture du lecteur vidéo (théâtre / visionneuse) — mémorisée sur l'appareil.
export const SPEEDS = [1, 1.25, 1.5, 2];
const KEY = "yalola.video_speed";

export const readSpeed = () => {
  try {
    const v = parseFloat(localStorage.getItem(KEY));
    return SPEEDS.includes(v) ? v : 1;
  } catch { return 1; }
};

export const saveSpeed = (v) => {
  try { if (v === 1) localStorage.removeItem(KEY); else localStorage.setItem(KEY, String(v)); } catch { /* noop */ }
};

// « 1× », « 1,25× » (fr) / « 1.25× » (en)…
export const fmtSpeed = (v, lang = "fr") => {
  try { return `${new Intl.NumberFormat(lang, { maximumFractionDigits: 2 }).format(v)}×`; } catch { return `${v}×`; }
};
